<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M.667 11.333V4.667h4v6.666h-4Zm10.666 0V4.667h4v6.666h-4ZM2 10h1.333V6H2v4Zm10.667 0H14V6h-1.333v4Z"
        />
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M6 11.333V4.667h4v6.666H6ZM8.667 10V6H7.333v4h1.334Z"
            clip-rule="evenodd"
        />
    </svg>
</template>

<script setup lang="ts">
type TileRowIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<TileRowIconProps>();
</script>
